<template>

    <div>
        <div id="administrarInstructivoEmbarque">
            <ui-modal ref="modal" title="Administrar Instructivo de embarque" @close="ActionSetZindexTablaModal(false); actionSetAbrirAgregarInstructivoEmbarque(false)">
                <h6>Hooola mundo</h6>
            </ui-modal>
        </div>
    
    </div>
  </template>
  
  <script>
    
    import { mapState, mapActions } from 'vuex';

    // UI Modal
    import UiModal from "keen-ui/src/UiModal";
    
    export default {

        data() {
            return {

            };
        },

        components: {
            UiModal,
        },

        computed : {

            ...mapState("serviciosLogisticos",["abrirAgregarInstructivoEmbarque"]),

        },

        methods: {

            ...mapActions(["ActionSetZindexTablaModal"]),
            ...mapActions("serviciosLogisticos",["actionSetAbrirAgregarInstructivoEmbarque"]),
        
            openModal(ref) {
                this.$refs[ref].open();
            },
            
            closeModal(ref) {
                this.$refs[ref].close();
            },

        },

        watch : {

            abrirAgregarInstructivoEmbarque : function(_new){

                _new ? this.openModal("modal") : this.closeModal('modal');

            }

        }

    };

  </script>
  
  <style>
    #administrarInstructivoEmbarque .ui-modal--size-normal > .ui-modal__wrapper > .ui-modal__container {
        width: 75% !important;
    }
  </style>
  